import avatarImage from "../../../assets/images/avatar.svg";
import birthdayIcon from "../../../assets/images/birthdayicon.svg";
import { formatCalendarDate, formatPhoneNumber } from "../../../Utils/helper";

const ContactHeading = ({ children }) => <h4 className="case-merge-contact-heading">{children}</h4>;

const ClientDetails = ({ client }) => {
  const ssn =
    client.ssn === null || client.ssn === undefined
      ? ""
      : String(client.ssn)
          .padStart(9, "0")
          .replace(/^(\d{3})(\d{2})(\d{4})$/, "$1-$2-$3");

  return (
    <div className="case-merge-client-details">
      <div className="case-merge-client-name">
        <img
          src={client.profile_pic_63p || client.profile_pic || avatarImage}
          width="19"
          height="19"
          alt=""
        />
        <strong>
          {client.last_name}, {[client.first_name, client.middle_name].filter(Boolean).join(" ")}
        </strong>
      </div>
      <dl className="case-merge-identification">
        {client.birthday && (
          <div>
            <dt className="visually-hidden">Birthday</dt>
            <dd className="case-merge-birthday">
              <img src={birthdayIcon} width="15" height="15" alt="" />
              <span>{formatCalendarDate(client.birthday)}</span>
              {client.age !== null && client.age !== undefined && (
                <>
                  <span className="font-weight-semibold text-primary-25">age</span>
                  <span>{client.age}</span>
                </>
              )}
            </dd>
          </div>
        )}
        <div>
          <dt className="text-primary-25">SSN</dt>
          <dd>{ssn}</dd>
        </div>
        <div>
          <dt className="text-primary-25">DL#</dt>
          <dd>
            {[client.driver_license_number, client.driver_license_state].filter(Boolean).join(" ")}
          </dd>
        </div>
      </dl>
      <ContactHeading>Phones</ContactHeading>
      {client.phones?.length ? (
        <div>
          {client.phones.map((phone) => (
            <div className="case-merge-contact-line info-color-panels-odd-even" key={phone.slot}>
              <span>
                {formatPhoneNumber(String(phone.number || ""))}
                {phone.ext ? ` ext. ${phone.ext}` : ""}
              </span>
              {phone.is_primary && <span className="case-merge-tag text-primary-25">Primary</span>}
            </div>
          ))}
        </div>
      ) : (
        <p className="case-merge-empty-contact text-primary-25">No phones on file.</p>
      )}
      <ContactHeading>Emails</ContactHeading>
      {client.emails?.length ? (
        <div>
          {client.emails.map((email) => (
            <div className="case-merge-contact-line info-color-panels-odd-even" key={email.slot}>
              <span>{email.email}</span>
              {email.is_primary && <span className="case-merge-tag text-primary-25">Primary</span>}
            </div>
          ))}
        </div>
      ) : (
        <p className="case-merge-empty-contact text-primary-25">No emails on file.</p>
      )}
      {client.addresses?.length ? (
        client.addresses.map((address) => (
          <div key={address.slot}>
            <ContactHeading>
              {address.is_mailing ? "Mailing Address" : `Address ${address.slot}`}
            </ContactHeading>
            <address className="case-merge-address">
              {address.address1 && <div>{address.address1}</div>}
              {address.address2 && <div>{address.address2}</div>}
              <div>
                {[address.city, [address.state, address.zip].filter(Boolean).join(" ")]
                  .filter(Boolean)
                  .join(", ")}
              </div>
            </address>
          </div>
        ))
      ) : (
        <>
          <ContactHeading>Addresses</ContactHeading>
          <p className="case-merge-empty-contact text-primary-25">No addresses on file.</p>
        </>
      )}
    </div>
  );
};

export default ClientDetails;
